import { DependenciesInjection } from "app/di/DependencyInjection";
import { SystemUserImpl } from "../data/SystemUserImpl";
import { ISystemUserRepository } from "../domain/repositories/ISystemUserRepository";
import { SystemUserUseCase } from "../domain/useCases/SystemUserUseCase";
import { SystemUserToken } from "./SystemUserToken";
import { SystemUserViewModel } from "../presentation/viewModel/SystemUserViewModel";

export class SystemUserInjection {
  static initInjections() {
    DependenciesInjection.register<ISystemUserRepository>(
      SystemUserToken.ISystemUserRepository,
      SystemUserImpl,
      "otherRepo",
    );
    DependenciesInjection.register<SystemUserUseCase>(
      SystemUserToken.SystemUserUseCase,
      SystemUserUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<SystemUserViewModel>(
      SystemUserToken.SystemUserViewModel,
      SystemUserViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<ISystemUserRepository>(
      SystemUserToken.ISystemUserRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<SystemUserUseCase>(
      SystemUserToken.SystemUserUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<SystemUserViewModel>(
      SystemUserToken.SystemUserViewModel,
    );
  }
}
